__turbopack_context__.v({
  "content": "_7jDW-q_content",
  "description": "_7jDW-q_description",
  "hero-container": "_7jDW-q_hero-container",
  "lottie-container": "_7jDW-q_lottie-container",
  "root": "_7jDW-q_root",
  "video-container": "_7jDW-q_video-container",
});
